<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!-- 合同列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['admi:summary:list']" @load="handleWorkList" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="item in list" :key="item.custName" @click="toWorkDetails(item)">
        <div class="flex-c-center" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.monthTime }}考勤
                <span style="color: #07c160;" v-if="item.isConfirm == '2'">【已确认】</span>
                <van-tag type="warning" v-if="item.isConfirm == '1'">待确认</van-tag>
              </div>
            </div>
            <div class="main">
              <span>应出/实际出勤：{{ item.workDays }}/<span style="color: #1989fa;">{{ item.regularDays }}</span>天</span>
              <span v-if="item.isManage == 1">
                <span style="margin-left: 10px;" v-if="item.everyPresent=='100'">全勤奖：<span style="color: #ee0a24;">100</span>元</span>
                <img v-if="item.everyPresent=='100'" class="zanImg" src="../../../assets/images/desktop/zan01.png" />
              </span>
              <!-- <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.workDays">应出勤：{{ item.workDays }}天</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.regularDays">计薪出勤：{{ item.regularDays }}天</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary">全勤奖：{{ item.everyPresent=='0'?'否':'是' }}</van-tag> -->
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toWorkDetails(item)" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 合同列表区 end -->
  </div>
</template>
<script>
import moment from 'moment'
import {
  Search,
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Grid,
  GridItem,
  Tab,
  Uploader,
  Tabs,
  Form,
  Calendar
} from 'vant'
import { listSummary, getSummary } from '@/api/admi/checkwork'
import SearchComponent from '@/components/common/Search'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
export default {
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Calendar.name]: Calendar,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    SearchComponent,
    EmptyComponent,
    TotalComponent
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: ''
      },
      loading: false,
      finished: false,
      noConLoading: false,
      noConFinished: false,
      failConLoading: false,
      failConFinished: false,
      otherConLoading: false,
      otherConFinished: false,
      showFilterPop: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      list: [],
      total: 0,
      noList: [],
      failList: [],
      otherList: [],
      type: 'add',
      show: false,
      searchParams: {
        visible: false
      },
      searchValue: '',
      custList: [],
      // 客户等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 提单状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 释放类型
      releaseModeOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      // 产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.contractBusinessType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      active: 0,
      // 列表
      activeName: 'active_nocontract',
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        remark: null
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        // userName: this.$store.state.user.user.nickName
        userId: this.$store.state.user.user.userId
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = 'ADMI-考勤列表'

      await this.handleWorkList()
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.userId = this.$store.state.user.user.userId
      this.queryParams.dateTime = this.searchValue = data
      this.queryWorkList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryWorkList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryWorkList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleWorkList()
    },
    // 返回布尔值
    beforeRead(file) {
      if (file.type !== 'pdf') {
        Toast('请上传 pdf 格式图片')
        return false
      }
      return true
    },
    // 返回布尔值
    beforeFileRead(file) {
      if (file.type !== 'pdf') {
        Toast('请上传 pdf 格式图片')
        return false
      }
      return true
    },
    toWorkDetails(item) {
      this.$router.push({
        name: 'checkWorkdetail',
        query: {
          id: item.id
        }
      })
    },
    async handleWorkList() {
      this.loading = true
      const res = await listSummary(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: '1',
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: '1',
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null
      }
    },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: '0',
        delFlag: null,
        remark: null
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.flex-c-center{
  .custName-wrap{
    .custName{
      font-size: 30px;
    }
  }
  .main{
    display: flex;
    align-items: flex-start;
    font-size: 24px;
    color: #333;
    .zanImg{
      width: 45px;
      margin-left: 20px;
    }
  }
}
</style>
